module.exports = __webpack_public_path__ + "static/gps_satellitesys-ffa0870a4c806385bafeb0ab2b401668.png";